import { ChangeDetectorRef, Component, inject, OnInit } from "@angular/core";
import { CustomModal } from "../../../core/components/base-modals";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Helper } from "@helpers/functions";

@Component({
	templateUrl: "./blockpit-tax-modal.component.html",
	styleUrls: ["./blockpit-tax-modal.component.scss"],
	standalone: false
})
export class BlockpitTaxModalComponent extends CustomModal implements OnInit {
	private readonly cdr = inject(ChangeDetectorRef);

	public newItems: BlockpitItem[] = [
		{
			key: 0,
			icon: "icon-svg-api"
		},
		{
			key: 1,
			icon: "icon-svg-tax"
		},
		{
			key: 2,
			icon: "icon-svg-percentage"
		}
	];

	private blockpitUrl: string = "";

	public constructor(private apicallService: ApicallService) {
		super();
	}

	public ngOnInit(): void {
		this.apicallService.get("user/blockpit/link", new ApicallOption(BlockpitLinkModel)).subscribe(
			(res: BlockpitLinkModel[]) => {
				this.blockpitUrl = res[0].getBlockpitUrl();
				this.cdr.markForCheck();
			},
			(error) => Helper.handleError(error)
		);
	}

	public openBlockpitLink(): void {
		window.open(this.blockpitUrl, "_blank");
	}

	public isButtonDisabled(): boolean {
		return this.blockpitUrl.length === 0;
	}
}

class BlockpitLinkModel {
	private value: string = "";

	public getBlockpitUrl(): string {
		return this.value;
	}
}

interface BlockpitItem {
	key: number;
	icon: string;
}
